<template>
    <div class="mapWrapper">
        <div ref="map" class="map"></div>
    </div>
</template>


<script>
  let deDuplicate = function(allMarkerPositions, currentMarkerPosition) {
    //Position for marker, could be updated if another marker already exists in same position
    let newPosition = currentMarkerPosition;
    //check to see if any of the existing markers match the latlng of the new marker
    let whileCount = 0;
    while (allMarkerPositions[newPosition.lat()]
    && allMarkerPositions[newPosition.lat()].has(newPosition.lng())) {
      //Subtract on odd numbers, add on even
      let posNeg = 1;
      if (whileCount % 2 === 1) {
        posNeg = -2;
      }
      //Change lat half the time, lng the other half, moves by ~300m each time
      if (whileCount > 1) {
        newPosition = new google.maps.LatLng(newPosition.lat() + posNeg * 0.005, newPosition.lng());
      } else {
        newPosition = new google.maps.LatLng(newPosition.lat(), newPosition.lng() + posNeg * 0.005);
      }
      whileCount++;
    }
    if (!allMarkerPositions[newPosition.lat()]) {
      allMarkerPositions[newPosition.lat()] = new Set();
    }
    allMarkerPositions[newPosition.lat()].add(newPosition.lng());
    return newPosition;
  };


  import MarkerClusterer from '@google/markerclustererplus';
  import _ from 'lodash-es';
  export default {
    name: 'TrailMap',
    props: ["trails", "selectedTrailId", "mapCenter", "newLocationMarker"],
    data: function () {
      //Set up a promise we can trigger when the map is loaded
      let mapResolve;
      let googleMap = new Promise(resolve => mapResolve = resolve);
      googleMap.resolve = mapResolve;

      return {
        markersByTrailId: {},
        locationsByTrailId: {},
        selectedMarker: null,
        googleMap: googleMap,
        markerClusterer : null,
        newLocationMarkerGoogle: null
      }
    },
    beforeMount: function () {
      this.$googlePromise.then(() => {
        this.initMap();
      });
    },
    computed: {
      trailsById() {
        return _.keyBy(this.trails, trail => trail.id);
      },
      //Trails which dont have a lat & lng
      trailIdsNoLocation() {
        return this.trails.filter(trail => !(trail.longitude && trail.latitude))
          .map(trail => trail.id);
      },
      //Deduplicated LatLng for all trails
      latLngByTrailId() {
        let latLngByTrailId = {};
        let allMarkerPositions = [];
        this.trails.filter(trail => (trail.longitude && trail.latitude))
          .forEach(trail => {
            let coordinates = new google.maps.LatLng(trail.latitude, trail.longitude);
            latLngByTrailId[trail.id] = deDuplicate(allMarkerPositions, coordinates);
          })
        return latLngByTrailId;
      }
    },
    watch: {
      newLocationMarker(newMarker) {
        if (!newMarker) {
          if (this.newLocationMarkerGoogle) {
            this.newLocationMarkerGoogle.setMap(null);
          }
          this.newLocationMarkerGoogle = null;
        } else {
          if (this.newLocationMarkerGoogle) {
            this.newLocationMarkerGoogle.setMap(null);
          }
          this.googleMap.then(map=> {
            let newLocationImage = {
              url: require("@/assets/rainbowlocation.png"),
              scaledSize: new google.maps.Size(21, 30)
              //labelOrigin: {x: 14, y: 15}
            };

            this.newLocationMarkerGoogle = new google.maps.Marker({
              position: newMarker,
              map: map,
              label: "",
              icon: newLocationImage
            });
          })
        }
      },
      mapCenter(newCenter) {
        this.googleMap.then(map => {
          map.setCenter(newCenter);
          map.setZoom(13);
        });
      },
      trails: {
        handler(newTrails, oldTrails) {
          this.googleMap.then(map => {
            let currentCenter = map.getCenter();
            let currentZoom = map.getZoom();
            this.addTrailsToMap(map);
            map.setCenter(currentCenter);
            map.setZoom(currentZoom);
          });
          }
      },
      selectedTrailId: {
        immediate: true,
        handler: function(newTrailId) {
          this.selectMarker(newTrailId);
        },
      }
    },
    methods: {
      selectTrailId : function(newTrailId) {
        this.$emit("selectTrailId", newTrailId);
      },
      selectMarker : function(trailId) {
        this.googleMap.then(() => {
          if (this.selectedMarker) {
            this.selectedMarker.setIcon(undefined);
            this.selectedMarker.setZIndex(undefined);
          }
          let selectedImage = {
            url: "/images/spotlight-poi-dotless2blue.png",
            labelOrigin: {x: 14, y: 15}
          };
          let marker = this.markersByTrailId[trailId];
          if (marker) {
            marker.setIcon(selectedImage);
            marker.setZIndex(google.maps.Marker.MAX_ZINDEX + 69);
            this.selectedMarker = marker;
            if (marker.map == null) {
              //marker is in a cluster, zoom in to it
              this.googleMap.then(map => {
                map.setCenter(marker.position);
                let zoomInListerner;
                let zoomIn = function () {
                  if (marker.map == null) {
                    map.setZoom(map.getZoom() + 1);
                  } else {
                    google.maps.event.removeListener(zoomInListerner);
                  }
                }
                zoomInListerner = google.maps.event.addListener(map, 'idle', zoomIn);
              });
            }
            //TODO zoom or not on initial select?
          } else {
            console.log(`Missing marker for trail id ${trailId} `)
          }
        });
      },
      resetMarkerClusterer(allMarkers) {
        this.googleMap.then(map => {
          if (!this.markerClusterer) {
            this.markerClusterer = new MarkerClusterer(map, allMarkers, {
              maxZoom: 9,
              gridSize: 30,
              styles: [
                MarkerClusterer.withDefaultStyle({
                  url: require('../assets/m1.png'),
                  width: 53,
                  height: 53,
                })
              ]
            });
          } else {
            while (true) {
              //removeMarkers doesn't actually remove all the specified markers, needs multiple calls
              // TODO: make sure we dont get stuck here. Also TODO: why are we loading again when switch Map to List?
              if (this.markerClusterer.removeMarkers(this.markerClusterer.getMarkers()) == false) {
                break;
              }
            }
            this.markerClusterer.addMarkers(allMarkers);
          }
        });
      },
      initMap: function() {
        let mapElement = this.$refs["map"];
        let map = new google.maps.Map(mapElement, {
          zoom: 8,
          center: this.mapCenter || new google.maps.LatLng( 43.07259800346519, -71.52585889999999),
          mapTypeControlOptions: {
            position: google.maps.ControlPosition.LEFT_BOTTOM
          },
          fullscreenControl: false
        });
        //Continue once the map is finished loading, bounds_changed seems to be the bizarre way to detect this.
        let listenerReference;
        let finishInitialization = () => {
          if (map.getBounds()) {
            google.maps.event.removeListener(listenerReference);
            this.addTrailsToMap(map);
            this.googleMap.resolve(map);
          }
        }
        listenerReference = map.addListener('bounds_changed', finishInitialization);
      },
      addTrailsToMap : function(map) {
        let bounds = new google.maps.LatLngBounds();
        let allMarkers = [];
        //Create a marker for all trails with a location
        //TODO clean up data (some missing trail.latlng cause poorly formed location): make this more resilient
        _.forEach(this.latLngByTrailId, (coordinates, trailId) => {
          let trail = this.trailsById[trailId];
          //Expand map bounds so new marker is visible
          bounds.extend(coordinates);
          
          let originalMaxZoom = map.maxZoom;
          map.setOptions({maxZoom: Math.max(11, map.zoom)});
          map.fitBounds(bounds);       // auto-zoom
          map.panToBounds(bounds);     // auto-center
          map.setOptions({maxZoom: originalMaxZoom});

          //Create new marker
          let marker = new google.maps.Marker({
            position: coordinates,
            map: map,
            label: String(trail.trailOrdinal),
            clickable: true
          });
          marker.addListener('click', () => {
            this.selectTrailId(trail.id);
          });
          if (this.markersByTrailId[trail.id]) {
            //Remove any existing marker for the trail from the map
            this.markersByTrailId[trail.id].setMap(null);
          }
          this.markersByTrailId[trail.id] = marker;
          allMarkers.push(marker);
          if (trail.id === this.selectedTrailId) {
            //Select this marker if it corresponds to the selected Trail
            this.selectMarker(this.selectedTrailId);
          }
        });
        this.resetMarkerClusterer(allMarkers)
      }
    }
  }
</script>

<style scoped lang="scss">
    .mapWrapper {
        height: 100%;
        width: 100%;
    }
    .map {
        width:100%;
        height: 100%;
        min-width: 320px;
        min-height: 320px;

        //max-height viewport calculation - fixed? Collapse pack when too big
        display: flex;
        flex-direction: column;
        align-self: stretch;
    }
</style>
